export default __webpack_public_path__ + "static/media/splash.eaf44dd4.jpeg";